<template>
  <a-config-provider :locale="zhCN">
    <layouts>
      <router-view />
    </layouts>
  </a-config-provider>
</template>

<script setup>
import { useStore } from "vuex";
import { onMounted, onUnmounted } from "vue";
import { postUserList } from '@/request/https/common';
import layouts from "@/layouts/index.vue";
import zhCN from 'ant-design-vue/es/locale/zh_CN';
import dayjs from 'dayjs';
import 'dayjs/locale/zh-cn';
dayjs.locale('zh-cn');

const store = useStore();
const ignoreErrors = [
  "ResizeObserver loop completed with undelivered notifications",
  "ResizeObserver loop limit exceeded",
];

window.addEventListener("error", (e) => {
  let errorMsg = e.message;
  ignoreErrors.forEach((m) => {
    if (errorMsg.startsWith(m)) {
      if (e.error) console.error(e.error.stack);
      const resizeObserverErrDiv = document.getElementById(
        "webpack-dev-server-client-overlay-div"
      );
      const resizeObserverErr = document.getElementById(
        "webpack-dev-server-client-overlay"
      );
      if (resizeObserverErr) resizeObserverErr.setAttribute("style", "display: none");
      if (resizeObserverErrDiv) resizeObserverErrDiv.setAttribute("style", "display: none");
    }
  });
});

/**
 * @function 获取钉钉员工列表
 */
const getDingtalkUserList = async () => {
  const res = await postUserList({
    rootDingTalkDeptIds: [908727248, 908642255],
    excludeUserIds: null
  });
  if (res.code == 0) store.dispatch('setDingtalkUserList', res.data);
};

/**
 * @function 设置主题色
 */
const setThemeColor = () => {
  if (localStorage.getItem('chu_xin_theme')) {
    const colorData = JSON.parse(localStorage.getItem('chu_xin_theme'));
    document.getElementsByTagName('body')[0].style.setProperty('--primary-color', colorData.c_1);
    document.getElementsByTagName('body')[0].style.setProperty('--hover-bg-color', colorData.c_2);
    document.getElementsByTagName('body')[0].style.setProperty('--hover-font-color', colorData.c_3);
    document.getElementsByTagName('body')[0].style.setProperty('--bg-color-1', colorData.c_4);
    document.getElementsByTagName('body')[0].style.setProperty('--bg-color-4', colorData.c_5);
  }
};

// rgba转16进制
// const getHexColor = (color) => {
//   let values = color
//     .replace(/rgba?\(/, '')
//     .replace(/\)/, '')
//     .replace(/[\s+]/g, '')
//     .split(',')
//   let a = parseFloat(values[3] || 1),
//     r = Math.floor(a * parseInt(values[0]) + (1 - a) * 255),
//     g = Math.floor(a * parseInt(values[1]) + (1 - a) * 255),
//     b = Math.floor(a * parseInt(values[2]) + (1 - a) * 255)
//   return '#' +
//     ('0' + r.toString(16)).slice(-2) +
//     ('0' + g.toString(16)).slice(-2) +
//     ('0' + b.toString(16)).slice(-2)
// }

/**
 * @function 全局键盘事件
 * @param e 
 */
const handleKeyDown = (e) => {
  if (e.key === 'Enter' || e.keyCode === 13) {
    window.dispatchEvent(new CustomEvent('global-search-enter'))
  }
}

onMounted(() => {
  setThemeColor();
  getDingtalkUserList();
  window.addEventListener('keydown', handleKeyDown);
});

onUnmounted(() => {
  window.removeEventListener('keydown', handleKeyDown);
});
</script>
